import { useId, type InputHTMLAttributes } from 'react';
import styles from './Field.module.css';

interface ToggleProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'role'> {
  readonly label: string;
}

/** Switch control (checkbox with `role="switch"`). */
export function Toggle({ label, id, ...rest }: ToggleProps) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  return (
    <label htmlFor={inputId} className={styles.toggle}>
      <input id={inputId} type="checkbox" role="switch" className={styles.toggleInput} {...rest} />
      <span aria-hidden="true" className={styles.track}>
        <span className={styles.thumb} />
      </span>
      <span>{label}</span>
    </label>
  );
}
